import '../styles/badge.css';

// TSS vite/01 — badge de estado compartido. Tonos semánticos por token
// (--color-warning/-success/-danger + fondos --color-*-soft de global.css):
//   warn  → pendiente / en revisión
//   good  → verificado / activo
//   bad   → rechazado / eliminado
//   muted → neutro / desconocido
// Entidad-agnóstico: el caller mapea su estado de dominio al tone.
export default function Badge({ tone = 'muted', children }) {
    return <span className={`badge badge--${tone}`}>{children}</span>;
}
